<template>
  <div class="modal-container" :style="modalContainerStyle" @click="onModalClick">
    <div class="modal-content">
      <img class="close-button" src="~images_base/close.svg" @click="onClose" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['open'],
  computed: {
    modalContainerStyle () {
      return {
        display: this.open ? 'block' : 'none'
      }
    }
  },
  watch: {
    open () {
      this.$blockScroll(this.open)
    }
  },
  methods: {
    onModalClick (e) {
      if (e.target.className && e.target.className.indexOf && e.target.className.indexOf('modal-container') > -1) {
        this.onClose()
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000000, 0.75);

  .modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    background-color: #FFFFFF;
    overflow-y: auto;

    img.close-button {
      pointer-events: all;
      cursor: pointer;
      width: 25px;
      height: 25px;
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 10;
    }
  }
}
</style>
